import React from 'react';
import logoWs from '../images/LANDING-PAGE-marketBiz_11.jpg';
import logoInsta from '../images/LANDING-PAGE-marketBiz_10.jpg';
import logoFace from '../images/LANDING-PAGE-marketBiz_09.jpg';
import politPriv from '../documents/eba.pdf';

function FooterContact() {

    const containerStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        gap: '5px',
        margin: '10px 0',
        flexWrap: 'wrap', // Allow wrapping
    };
    
  return (
    <footer style={{ fontSize: '0.9rem', lineHeight: '1.2', gap: '30px' }}>
      <div style={{ padding: '0px' }}>
        {/*
        <button
          className="large-button-contact"
          onClick={() => (window.location.href = 'mailto:d.vargas@marketbiz.ai')}
          style={{ margin: '5px 0', fontSize: '0.8rem', padding: '8px 12px' }}
        >
          CONTÁCTANOS
          <img
            src={imageEmail}
            alt="Icono"
            className="button-icon"
            style={{ width: '16px', height: '16px', marginLeft: '8px' }}
          />
        </button>
        */}
        <div
          
          style={containerStyle}
        >
          <div className="column" style={{ textAlign: 'center' }}>www.marketBiz.ai</div>
          <div className="column" style={{ textAlign: 'center' }}>+57(322)7351427</div>
          <div className="column" style={{ textAlign: 'center' }}>d.vargas@marketBiz.ai</div>
        </div>

        <p
          style={{
            fontSize: '0.7rem',
            fontWeight: 'normal',
            margin: '5px 0',
            color: 'grey',
            textAlign: 'center',
          }}
        >
          Copyrigthed © 2024 Colombia - EE.UU
        </p>

        <div
          className="three-column-container"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            margin: '5px 0',
          }}
        >
          <div className="column"></div>
          <div>
            <div
              className="three-column-container"
              style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}
            >
              <div className="column">
                <a
                  href="https://www.facebook.com/share/qWrWMLdh3SrShSP9/?mibextid=LQQJ4d"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={logoFace} alt="logo Facebook" style={{ width: '40px', height: '40px' }} />
                </a>
              </div>
              <div className="column">
                <a
                  href="https://www.instagram.com/market_biz_ai"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={logoInsta} alt="logo Instagram" style={{ width: '40px', height: '40px' }} />
                </a>
              </div>
              <div className="column">
                <a
                  href="https://api.whatsapp.com/send?phone=573227351427"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={logoWs} alt="logo WhatsApp" style={{ width: '40px', height: '40px' }} />
                </a>
              </div>
            </div>
          </div>
          <div className="column"></div>
        </div>

        <a
          href={politPriv}
          target="_blank"
          rel="noopener noreferrer"
          className="privacy-link"
          style={{ fontSize: '0.7rem', textDecoration: 'underline', margin: '10px 0' }}
        >
          Política de Privacidad
        </a>
      </div>
    </footer>
  );
}

export default FooterContact;
